import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// import { AngularFireDatabaseModule } from '@angular/fire/database';
// import { AngularFireAuthModule } from '@angular/fire/auth';
// import { AngularFireMessagingModule } from '@angular/fire/messaging';
// import { AngularFireModule } from '@angular/fire';
// import { FirebaseMessagingService } from './core/firebase/firebase-messaging.service';

import { MbscModule } from '@mobiscroll/angular';
import { JwtModule } from '@auth0/angular-jwt';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ErrorHandlerService } from './core/framework/error-handler.service';
import { AppRoutingModule } from './app.routes';
import { HttpInterceptorService } from './core/framework/http-interceptor.service';
import { BreadcrumbService } from './core/framework/breadcrumb.service';
import { ToasterService } from './core/framework/toaster/toaster.service';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';



export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: "right",
  allowNegative: true,
  decimal: ",",
  precision: 2,
  prefix: "R$ ",
  suffix: "",
  thousands: "."
};



@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    MbscModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    CoreModule,
    JwtModule,
    HttpClientModule,
    ConfirmDialogModule,
    LeafletModule,
    AppRoutingModule,
    // AngularFireDatabaseModule,
    // AngularFireAuthModule,
    // AngularFireMessagingModule,
    // AngularFireModule.initializeApp(environment.firebase),
  ],
  exports: [],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    ErrorHandlerService,
    HttpClientModule,
    ConfirmationService,
    BreadcrumbService,
    ToasterService,
    // FirebaseMessagingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

